import { usePartnersListing } from "../../../../lib/react-query/partners.ts";

// Local Imports
import {
  EmptyState,
  PartnerCard,
  PartnerCardSkeletonGrid,
} from "../../../../components/shared";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { getFullName, getPartnerLocationLabel } from "../../../../utils/utils";

const SuggestedPartners = () => {
  const { data: partnersListing, isLoading: partnersLoading } = usePartnersListing({ suggested_page: 1, suggested_page_size: 10 });

  return (
    <>
      {partnersLoading ? (
        <PartnerCardSkeletonGrid count={9} />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 base:grid-cols-3 gap-4 pb-6 mt-6">
          {partnersListing?.suggested_partners?.results?.length > 0 ? (
            partnersListing?.suggested_partners?.results?.map((item) => {
              return (
                <PartnerCard
                  key={item?.id}
                  src={item?.profile_image}
                  name={getFullName(item)}
                  designation={item?.profession}
                  address={getPartnerLocationLabel(item)}
                  id={item?.id}
                  item={item}
                />
              );
            })
          ) : (
            <EmptyState compact icon={HiOutlineUserGroup} title="No suggested connections" description="Suggested connections will appear here." className="my-6" />
          )}
        </div>
      )}
    </>
  );
};

export default SuggestedPartners;
